export const normalizeId = (id?: string) => (id?.startsWith('custom-') ? undefined : id);
